import type { ColumnVisibilityItem } from "providers/Auth";

export const PROPERTIES_COLUMNS_TAB_KEY = "properties";

/**
 * Boom's standard order for the Properties table (CRM-1891). Users can reorder these columns by
 * dragging headers but can't hide any, so every one is always shown. Ids match the grid's colIds
 * and the API's Boom::Partner::User::PROPERTIES_DEFAULT_COLUMNS.
 */
export const DEFAULT_PROPERTIES_COLUMNS: ColumnVisibilityItem[] = [
  ["address", "Property"],
  ["total_units", "Units"],
  ["property_group.name", "Property group"],
  ["owner", "Owner"],
  ["pms_id", "Source"],
  ["screening_template", "Screening template"],
  ["listing_template", "Listing template"],
  ["contact_phone", "Contact phone"],
  ["contact_email", "Contact email"]
].map(([id, label]) => ({
  id,
  label,
  checked: true,
  disabled: false,
  always_on: true
}));
